import { render, staticRenderFns } from "./ObjectTab.vue?vue&type=template&id=cc6a45fc&scoped=true"
import script from "./ObjectTab.vue?vue&type=script&lang=ts"
export * from "./ObjectTab.vue?vue&type=script&lang=ts"
import style0 from "./ObjectTab.vue?vue&type=style&index=0&id=cc6a45fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6a45fc",
  null
  
)

export default component.exports